module.exports = __webpack_public_path__ + "media/success.31c3706e.wav";